const nodeContainsTarget = (node: Node, target: EventTarget) => {
  if (!(target instanceof Node)) return false;

  return node.contains(target);
};

export {
  nodeContainsTarget,
};
